import script from "./CategoryLozenge.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoryLozenge.vue?vue&type=script&setup=true&lang=ts"

import "./CategoryLozenge.vue?vue&type=style&index=0&id=f1e34614&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1e34614"]])

export default __exports__